'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationConfirmationController = function () {
    function WinresReservationConfirmationController($scope) {
        _classCallCheck(this, WinresReservationConfirmationController);

        this.$scope = $scope;
        this.$scope._ = _;
        this.$scope.r = null; // The result
        this.$scope.cabinNumbersInUse = null;
        this.$scope.orderedProductLines = [];
        this.$scope.servicesWithoutParent = [];
    }

    _createClass(WinresReservationConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getConfirmBookingResult()

            var contextFromPopup = null;
            for (var s = this.$scope; s != null; s = s.$parent) {
                if (s.hasOwnProperty('contextForPopup')) {
                    contextFromPopup = s.contextForPopup;
                    break;
                }
            }

            var wrc = contextFromPopup || this.winresReservationContext;
            if (!wrc) {
                throw new Error('Context must be provided, either by the popup or the old-fashioned way.');
            }

            this.data = wrc.getContext();

            this.$scope.$watch(function () {
                return wrc.getConfirmBookingResult();
            }, function (result) {
                // "r" is the confirmation result.
                _this.$scope.r = result;

                if (result) {
                    var productLines = result.Booking.Productlines.products;

                    // Combine day linked products to single products.
                    productLines = combineDayLinkedProducts(productLines);

                    // Order the product lines, placing dependent lines (discounts and services)
                    // below their parents.
                    productLines = orderProductLines(productLines);

                    _this.$scope.orderedProductLines = productLines;

                    // Booking discounts and independent services.
                    _this.$scope.otherProductLines = _.remove(_this.$scope.orderedProductLines, function (product) {
                        return product.DestinationInfo && !product.DestinationInfo.Accommodation && !isServiceWithParent(product) && !isDiscountForProductLine(product);
                    });

                    _this.addCabinNumberEnabledInfoToPassengersIfEnabled(result);

                    var closeListener = _this.$scope.$on('close-popup', function () {
                        var href = window.sessionStorage.getItem('originalUrl');
                        if (href) {
                            _this.data.Products = [];
                            _this.data.DiscountProducts = [];
                            window.sessionStorage.removeItem('originalUrl');

                            if (wrc.$scope.okUrl) {
                                window.location.href = window.location.origin + window.location.pathname; // Do not return.
                            } else {
                                window.location.href = href; // Return to normal kohdesivu
                            }
                        }
                        closeListener(); // Remove close popup broadcast listener
                    });
                }
            });
        }
    }, {
        key: 'isChild',
        value: function isChild(line) {
            return isDiscountForProductLine(line) || isServiceWithParent(line);
        }

        // This returns true if ProductHasCabinNumbers is true for given destinationCode and ProductCode

    }, {
        key: 'doesProdHaveCabinNumber',
        value: function doesProdHaveCabinNumber(response, DestinationCode, ProductCode) {
            var _this2 = this;

            var produclinesProds = response.Booking.Productlines.products;
            return _.find(produclinesProds, function (p) {
                var hasCabinNum = p.DestinationInfo.ProductHasCabinNumbers;
                var DCode = p.DestinationInfo.DestinationCode;
                var PCode = p.DestinationInfo.ProductCode;

                if (DCode === DestinationCode && PCode === ProductCode && hasCabinNum === true) {
                    _this2.$scope.cabinNumbersInUse = true;
                    return true;
                }
            });
        }

        // This loops through all products assigned to passenger
        // and uses doesProdHaveCabinNumber() helper function to check from productlines products
        // if ProductHasCabinNumbers attribute is true
        // and then adds a field to the passenger assigned product
        // so that we can conviniently know in template whether to display
        // the cabin number or not.
        // This is because the given cabinnumber in the response might be fake (or just generated?)
        // But if ProductHasCabinNumbers is true, then we can trust the cabin number
        // and display it

    }, {
        key: 'addCabinNumberEnabledInfoToPassengersIfEnabled',
        value: function addCabinNumberEnabledInfoToPassengersIfEnabled(response) {
            var _this3 = this;

            var passengers = response.Booking.Passengers;
            _.each(passengers, function (passenger) {
                _.each(passenger.Products, function (prod) {
                    if (prod.ServiceType === "MA") {
                        if (_this3.doesProdHaveCabinNumber(response, prod.DestinationCode, prod.AccommodationProductCode)) {
                            prod.shouldDisplayCabinNumber = true;
                            // the function return the productline product
                            var productLineProd = _this3.doesProdHaveCabinNumber(response, prod.DestinationCode, prod.AccommodationProductCode);
                            // adding the productname to the assignedproduct to use in a template
                            prod.ProductName = productLineProd.DestinationInfo.ProductName;
                            console.log("Added shouldDisplayCabinNumber = true to the passenger assigned product: ", prod);
                        }
                    }
                });
            });
        }
    }, {
        key: 'getDate',
        value: function getDate(line) {
            if (line.BeginTime && line.EndTime) {
                if (line.BeginDate === line.EndDate) {
                    // Same day.
                    // Begin date with begin and end time.
                    return (0, _utils.formatDateWithTimes)(line.BeginDate, line.BeginTime, line.EndTime);
                } else {
                    // Date range with begin and end time.
                    return (0, _utils.formatDateRange)(line.BeginDate, line.EndDate, line.BeginTime, line.EndTime);
                }
            } else if (line.LinkingInfo && line.LinkingInfo.Type === 'Day') {
                return (0, _utils.formatDateRange)(line.BeginDate, line.EndDate);
            } else if (line.ForceReservedDays > 0 || !line.DestinationInfo.Accommodation) {
                return (0, _utils.formatFinnishDatePretty)(line.BeginDate);
            } else {
                return (0, _utils.formatDateRange)(line.BeginDate, line.EndDate);
            }
        }
    }]);

    return WinresReservationConfirmationController;
}();

function orderProductLines(productLines) {
    // Make a copy to avoid mutating the original list,
    // in case the caller wants to keep using it.
    var unsorted = _.toArray(productLines);

    // Take any per-line discounts.
    var perLineDiscounts = _.remove(unsorted, isDiscountForProductLine);

    // Take any services with a defined parent.
    var services = _.remove(unsorted, isServiceWithParent);

    // Anything remaining in the unsorted list at this point should be an independent product line.
    // Sort them, first by start date, then accommodations first.
    var mainLines = _.sortBy(unsorted, [function (line) {
        return line && line.BeginDate;
    }, function (line) {
        return lineIsAccommodation(line) ? 0 : 1;
    }]);

    // Make a list of lists, with each sub-list containing an independent line and
    // all the child lines that should go under it.
    var lineLists = _.map(unsorted, function (parentLine) {
        var discs = _.remove(perLineDiscounts, function (discountLine) {
            return isDiscountFor(discountLine, parentLine);
        });
        var sers = _.remove(services, function (serviceLine) {
            return isServiceFor(serviceLine, parentLine);
        });
        var sortedSers = _.sortBy(sers, [serviceSortKey]); // Sort forced services first
        return _.concat([parentLine], discs, sortedSers);
    });

    // These should have all been sorted under their parent lines.
    // Just in case, gather them up.
    var orphans = _.concat(perLineDiscounts, services);
    if (orphans.length > 0) {
        console.error('[WSC] Cart contains orphan product lines:', _.cloneDeep(orphans));
    }

    return _.flatten(lineLists);
}

function isDiscountForProductLine(line) {
    return line && line.IsDiscountProduct && line.DiscountScope === 'ProductLine';
}

function isDiscountFor(discountLine, parentLine) {
    var d = discountLine && discountLine.DestinationInfo;
    var p = parentLine && parentLine.DestinationInfo;
    return d.DestinationCode === p.DestinationCode + '-DISCOUNT' && d.ProductCode === p.ProductCode + '-DISCOUNT';
}

function isServiceFor(serviceLine, parentLine) {
    return serviceLine && serviceLine.Parent && parentLine && parentLine.DestinationInfo && serviceLine.Parent.DestCode === parentLine.DestinationInfo.DestinationCode && (serviceLine.Parent.ProdCode === undefined || serviceLine.Parent.ProdCode === parentLine.DestinationInfo.ProductCode) && serviceLine.Parent.BeginDate === parentLine.BeginDate && serviceLine.Parent.EndDate === parentLine.EndDate;
}

function isServiceWithParent(line) {
    return line && line.Parent;
}

function lineIsAccommodation(line) {
    var di = line && line.DestinationInfo;
    return di && di.Accommodation;
}

function serviceSortKey(serviceLine) {
    var p = serviceLine;
    var li = p && p.LinkingInfo;
    return li && li.ForcingMode; // "Forced" sorts before "Normal"
}

function combineDayLinkedProducts(productLines) {
    // Make a copy to avoid mutating the original list.
    var productLinesClone = _.cloneDeep(productLines);

    // Remove day linked products from product list.
    var dayLinkedProducts = _.remove(productLinesClone, function (productLine) {
        return productLine.LinkingInfo && productLine.LinkingInfo.Type === 'Day';
    });

    // Create dest and prod code groups for day linked products.
    var dayLinkedProductGroupsByDestAndProdCode = _.groupBy(dayLinkedProducts, function (productLine) {
        return productLine.DestinationInfo.DestinationCode + '|' + productLine.DestinationInfo.ProductCode;
    });

    // Take one product per group.
    var singleDayLinkedProducts = _.map(dayLinkedProductGroupsByDestAndProdCode, function (dayLinkedProducts) {
        // Get lowest possible begin date and highest possible end date.
        var beginDate = dayLinkedProducts[0].BeginDate;
        var endDate = dayLinkedProducts[dayLinkedProducts.length - 1].BeginDate;

        var firstDayLinkedProduct = dayLinkedProducts[0];
        firstDayLinkedProduct.BeginDate = beginDate;
        firstDayLinkedProduct.EndDate = endDate;

        // Combine prices.
        // _.each(firstDayLinkedProduct.ReservablePrices, (reservablePrice, index) => {
        //     reservablePrice.Price = _.sumBy(dayLinkedProducts, productLine => productLine.ReservablePrices[index].Price);
        // });

        return firstDayLinkedProduct;
    });

    return _.concat(productLinesClone, singleDayLinkedProducts);
}

WinresReservationConfirmationController.$inject = ['$scope'];

_module3.default.component('winresReservationConfirmation', {
    template: require('./winresReservationConfirmation.html'),
    controller: WinresReservationConfirmationController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        showExtraServices: '@', // True/false defaults to true
        showPassengers: '@', // True/false defaults tu true
        showAccommodations: '@', // True/false defaults to true
        showNewReservationButton: '@' // True/false defaults to true
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationConfirmation/winresReservationConfirmation.js
// module id = 412
// module chunks = 2